'use client'

import { FormProvider } from 'react-hook-form'

import type { SelfAssessmentDefinition } from '@/src/domains/self-assessments/schemas'

import { SelfAssessmentStep } from './SelfAssessmentWizard.constants'
import { SelfAssessmentWizardContext } from './SelfAssessmentWizard.context'
import { useSelfAssessmentWizardForm } from './SelfAssessmentWizard.hooks'
import { SelfAssessmentWizardIntro } from './SelfAssessmentWizardIntro'
import { SelfAssessmentWizardQuestion } from './SelfAssessmentWizardQuestion'
import { SelfAssessmentWizardResult } from './SelfAssessmentWizardResult'

export interface SelfAssessmentWizardProps {
  definition: SelfAssessmentDefinition
}

const contentByStep = {
  [SelfAssessmentStep.INTRO]: SelfAssessmentWizardIntro,
  [SelfAssessmentStep.QUESTION]: SelfAssessmentWizardQuestion,
  [SelfAssessmentStep.RESULT]: SelfAssessmentWizardResult,
}

export const SelfAssessmentWizard = ({ definition }: SelfAssessmentWizardProps) => {
  const { form, wizard, handleSubmit, handleReset } = useSelfAssessmentWizardForm(definition)

  const Content = contentByStep[wizard.step]

  return (
    <FormProvider {...form}>
      <SelfAssessmentWizardContext.Provider value={wizard}>
        <form onSubmit={handleSubmit} onReset={handleReset}>
          <Content key={wizard.questionIndex} />
        </form>
      </SelfAssessmentWizardContext.Provider>
    </FormProvider>
  )
}
